import { Box, Typography } from '@mui/material';
import ResumeImage from 'assets/ResumeImage.webp';
import { allowedFilesMap } from './DataSetForm';

export default function ResumeDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Resume" Chunking Method Description</Typography>
      <Typography marginTop={1}>The supported file formats are {allowedFilesMap.resume.join(', ')}.</Typography>
      <Typography marginTop={3}>
        The resume comes in a variety of formats, just like a person's personality, but we often have to organize them
        into structured data that makes it easy to search.
      </Typography>
      <Typography>
        Instead of chunking the resume, we parse the resume into structured data. As a HR, you can dump all the resume
        you have, the you can list all the candidates that match the qualifications just by talk with 'RAGFlow'.
      </Typography>
      <Typography fontWeight='500' marginTop={3}>
        "Resume" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <img src={ResumeImage} alt='resume' />
    </Box>
  );
}
